import { useEffect, useRef } from 'react'
import {WhyGoSolar} from './WhyGoSolar.js'
import { Link } from 'react-router-dom'
import { ASSETS_URL } from '../utils/constants'

const prodHuaweiInverter = ASSETS_URL + 'huawei-inverter-total-solar-2.webp'
const prodTrinaSolar = ASSETS_URL + 'trina-solar-total-solar-2.png'
const prodLappKabel = ASSETS_URL + 'lapp-kabel-total-solar-1.jpeg'

export function Products() {
    const containerRef = useRef(null)

    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      }
    }, [containerRef])

    return <>
        <div ref={containerRef} className="font-[Montserrat] w-[80%] text-[#f7f7f7] text-left my-10 flex items-center flex-col">
          <div className='text-[#4CB117] text-center text-3xl sm:text-5xl font-extrabold pb-3 pt-3'>Products</div>

          <div className='flex flex-row flex-wrap justify-between pb-5'>
            <ProductCard name={'Huawei Solar Inverters'} warranty={'10 years warranty'} description={'Surge Protection and Arc Fault Protection'} pic={prodHuaweiInverter}/>
            <ProductCard name={'Trina Solar'}  warranty={'25 years warranty'} description={''} pic={prodTrinaSolar}/>
            <ProductCard name={'Lapp Kabel DC Wires & Cables'} warranty={'25 years warranty'} description={'UV-rated and Fireproof'} pic={prodLappKabel}/>
          </div>
          
          <div className='text-[#f7f7f7] text-center text-m mt-2 pb-20'>Learn more about our <Link to={'/services'} className='hover:underline text-[#4CB117]'>services</Link> </div>
          
          
          <WhyGoSolar />

          <div className='text-[#f7f7f7] text-center text-m mt-10'>Interested on our products? <Link to={'/contact'} className='hover:underline text-[#4CB117]'>Send us a message for a free quotation!</Link></div>
           
        </div>
    </>
}

const ProductCard = ({name, warranty, description, pic}) => {
  return <>
  <div className="flex flex-col w-full sm:w-[32%] h-auto bg-[#f7f7f7] shadow-lg rounded-lg overflow-hidden my-5 hover:shadow-[#4CB117]">
    <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="w-full h-[200px] sm:h-[300px] object-cover" src={pic} />
    <div className="w-full p-4">
      <h1 className="text-[#1E1C1C] font-bold text-lg sm:text-2xl">{name}</h1>
      <p className="mt-2 text-[#4CB117] text-sm">{warranty}</p>
      <p className="mt-2 text-[#1E1C1C] text-sm mb-2">{description}</p>
      <div className="hidden flex item-center mt-2">
        <svg className="w-5 h-5 fill-current text-gray-700" viewBox="0 0 24 24">
          <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"/>
        </svg>
        <svg className="w-5 h-5 fill-current text-gray-700" viewBox="0 0 24 24">
          <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"/>
        </svg>
        <svg className="w-5 h-5 fill-current text-gray-700" viewBox="0 0 24 24">
          <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"/>
        </svg>
        <svg className="w-5 h-5 fill-current text-gray-500" viewBox="0 0 24 24">
          <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"/>
        </svg>
        <svg className="w-5 h-5 fill-current text-gray-500" viewBox="0 0 24 24">
          <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"/>
        </svg>
      </div>
      <div className="hidden flex item-center justify-between mt-3">
        <h1 className="text-gray-700 font-bold text-xl">$220</h1>
        <button className="px-3 py-2 bg-gray-800 text-white text-xs font-bold uppercase rounded">Add to Card</button>
      </div>
    </div>
  </div>
  </>
}